import * as React from 'react';
import { useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});



const MainOffice = () => {

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Box sx={{ width: '100%' }}>
      <Divider flexItem sx={{ borderColor: '#555' }} />
        <Stack direction={'row'} justifyContent={'space-evenly'} sx={{height: '25px'}}>
          <Button onClick={() => navigate('../Policy/Terms')}>
            <Typography sx={{ fontSize: 12, color: '#ccc' }}>서비스이용약관</Typography>
          </Button>
          <Divider orientation="vertical" variant="middle" flexItem sx={{ borderColor: '#555' }} />
          <Button onClick={() => navigate('../Policy/Private')}>
            <Typography sx={{ fontSize: 12, color: '#ccc' }}>개인정보처리방침</Typography>
          </Button>
        </Stack>
        <Box pl={2.5} pb={0.5}>
          <Button onClick={() => navigate('../Policy/Collect')} sx={{height: '18px'}}>
            <Typography sx={{ fontSize: 10, color: '#ccc' }}>개인(민감)정보 수집 및 이용 동의</Typography>
          </Button>
          <Button onClick={() => navigate('../Policy/Third')} sx={{height: '18px'}}>
            <Typography sx={{ fontSize: 10, color: '#ccc' }}>제3자 개인정보 제공 동의(건강검진 및 심리상담)</Typography>
          </Button>
          <Button onClick={() => navigate('../Policy/Ads')} sx={{height: '18px'}}>
            <Typography sx={{ fontSize: 10, color: '#ccc' }}>홍보 및 마케팅 수집·이용 동의서</Typography>
          </Button>
        </Box>
        <Divider flexItem sx={{ borderColor: '#555' }} />
        <Box sx={{p:'5px 16px 10px 16px'}}>
          <Typography sx={{ fontSize: 14, mb: '5px', fontWeight: 700, color: '#ddd' }}>(주) 듀얼헬스케어</Typography>
          <Typography sx={{ fontSize: 12, mb: '5px', color: '#aaa' }}>대표자 : 김영이</Typography>
          <Typography sx={{ fontSize: 12, color: '#aaa' }}>대전광역시 유성구 대덕대로 512번길 20, A동 303호</Typography>

          <Stack direction={'column'} justifyContent={'center'}>
            <Typography sx={{ fontSize: 12, color: '#aaa' }}>사업자번호 : 111-86-01943</Typography>
            <Typography sx={{ fontSize: 12, color: '#aaa' }}>copyrightⓒdualhealthcare</Typography>
          </Stack>
        </Box>
        {/* <Stack direction={'row'} sx={{ mt: 2 }}>
              <a href="https://m.blog.naver.com/dualhealth_official" target="_blank" style={{ width: '50%', textAlign: 'right', marginRight: '20px' }}><img alt="Blog" src={blogIcon} style={{ width: '30px', opacity: '0.7' }} />  </a>
              <a href="https://www.instagram.com/dualhealth_official" target="_blank" ><InstagramIcon sx={{ color: '#929292', fontSize: 32 }} /></a>
            </Stack> */}



      </Box>





    </React.Fragment>
  );
}


export default MainOffice;

